import { Component, DoCheck, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { TicketCommentsComponent } from '../ticket-details/ticket-comments/ticket-comments.component';
import { TicketService } from '../ticket.service';
import { ImageEditorComponent } from '../../note-sidebar/wound-care-widget/image-editor/image-editor.component';

@Component({
  selector: 'app-user-ticket-details',
  templateUrl: './user-ticket-details.component.html',
  styleUrls: ['./user-ticket-details.component.css']
})
export class UserTicketDetailsComponent implements OnInit {

  @ViewChild(TicketCommentsComponent) child: TicketCommentsComponent;
  @Input() rowData;
  @Output() showDetail = new EventEmitter<any>();
  comments: string = '';
  currentUser: any;
  editComment: any = {};
  isPostEnabled: boolean = false;
  imageSrc: any;

  constructor(private ticketService: TicketService, 
    private authService: AuthService, 
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog
    ) { }


  ngOnInit() {
    if (this.rowData.attachment !== undefined && this.rowData.attachment.length > 0) {
      this.ticketService.getTicketImage(this.rowData.attachment[0]).subscribe((data: any) => {
        this.imageSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + data.data)
      })
    }
    this.currentUser = this.authService.currentUser;
  }

  goBack() {
    this.showDetail.emit(false);
  }

  postComments() {
    this.isPostEnabled = true;
    if (Object.values(this.editComment).length > 0) {
      this.ticketService.editComments(this.editComment._id, this.comments).subscribe((Response: any) => {
        if (Response.status == 200) {
          this.isPostEnabled = false;
          this.child.getComments();
          this.editComment = {};
          this.comments = '';
        } else {
          console.log('Response failed');
        }
      });
    } else {
      this.ticketService.postComments(this.rowData._id, this.comments, this.currentUser.first_name + ' ' + this.currentUser.last_name).subscribe((Response: any) => {
        if (Response.status == 200) {
          this.isPostEnabled = false;
          this.child.getComments();
          this.comments = '';
        } else {
          console.log('Response failed');
        }
      });
    }
  }

  viewFullImage() {
    const dialogRef = this.dialog.open(ImageEditorComponent, {
      width: 'auto',
      data: {
        src: this.imageSrc,
        editor: false,
        viewOnly: true
      }
    });
  }
}
